import React from 'react';
import TableDataField from './TableDataField';

const CodeRowNumber = ({rowIndex, codeRowField, height}) => {
    height = height ?? '40px';
    let classes = "col-x-small py-3 border-right border-dark text-center";
    return (
        <th scope="row" className={classes} style={{ height: height, maxHeight: height}} >
            {rowIndex === 0 ? codeRowField : ''}
        </th>
    )
};

export default CodeRowNumber;
